module.exports = __webpack_public_path__ + "static/media/datacamp.060aa306.webp";